import React from 'react';
import { Link } from 'react-router-dom';

import theme from 'config/themes';

const Logo = ({ to, inverse = false, ...rest }) => {
  const logoSrc = !inverse ? theme.logo : theme.logoInverse;
  const altText = `${theme.companyName} Logo`;
  let logo = <img src={logoSrc} width="100%" height="100%" alt={altText} />

  if (typeof to === 'string'){
    logo = <Link {...rest} to={to}>{logo}</Link>
  } else {
    logo = <div {...rest}>{logo}</div>
  }

  return logo;
};
export default Logo;
